<script setup lang="ts">

const props = defineProps<{
    title?: string;
    backgroundColor?: string;
    titleColor?: string;
    borderColor?: string;
    elevated?: boolean;
    paddingPx?: number;
    borderRadiusPx?: number;
}>();
</script>
<template>
    <div
        class="card-body"
        :style="`
            padding: ${props.paddingPx ?? 16}px;
            background-color: ${props.backgroundColor || 'white'};
            ${props.borderColor ? `border: 3px solid ${props.borderColor};` : ''}
            border-radius: ${props.borderRadiusPx ?? 8}px;
            ${props.elevated ? 'box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);' : ''};
        `"
    >
        <h3
            v-if="props.title"
            :style="`color: ${props.titleColor || 'black'};`"
            class="card-title"
        >
            {{ props.title }}
        </h3>
        <slot />
    </div>
</template>
<style scoped>
.card-title{
    text-align: center;
}

.card-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
</style>
